<template>
  <CommonNoticeCard
    icon="iconshishi"
    symbol-icon
    :title="data.summary"
    :class="b()"
    @click.native="view"
  >
    <div
      slot="content"
      :class="b('tip')"
    >
      <div v-if="data.tip">
        {{ data.tip }}
      </div>
    </div>
    <template #actions>
      <el-tooltip :content="$t('button.positionView')">
        <el-button
          v-if="showPosition"
          type="plaintext2"
          icon="zkicon iconicon_dingwei"
          size="mini"
          @click.stop="position"
        />
      </el-tooltip>
      <el-button
        type="plaintext2"
        icon="zkicon iconxianshi"
        size="mini"
        @click="view"
      >
        {{ $t('button.view') }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import theme from '@zk/theme/lib/variables.scss';
import { findDownComponent } from '@zk/framework-vue';

export default {
  name: 'EpicNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    data: {
      type: Object,
      required: true
    },
    root: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPosition: false
    };
  },
  created() {
    this.checkShouldShowPosition();
  },
  methods: {
    view() {
      this.eventBus.$emit('epic:edit', this.data);
    },
    position() {
      this.eventBus.$emit('epic:notice-position', this.data);
    },
    async checkShouldShowPosition(){
      const routeName = this.root.$route.name;
      if (routeName === 'epic-list'){
        if (!this.data?.id){
          return false;
        }
        const epicApp = document.querySelector('#micro-app_epic #app');
        if (!epicApp) {
          return false;
        }
        const epicPage = findDownComponent(epicApp.__vue__, 'EpicGantt');
        this.showPosition = await epicPage?.checkCreateEpicShouldShowPosition(this.data);
        return;
      }
      if (routeName === 'gantt'){
        const projectApp = document.querySelector('#micro-app_project #app');
        if (!projectApp) {
          return false;
        }
        const ganttPage = findDownComponent(projectApp.__vue__, 'GanttView');
        this.showPosition = await ganttPage?.checkCreateEpicShouldShowPosition(this.data);
        return;
      }
      if (routeName === 'roadmap'){
        const RoadmapComponentIndex = findDownComponent(this.root, 'RoadmapComponentIndex');
        this.showPosition = await RoadmapComponentIndex?.checkCreateEpicShouldShowPosition(this.data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(epic-notice-card) {
  @include e(tip) {
    color: var(--font-color-2);
  }
}
</style>
